import { SuperTeamTeamsPage } from "@fwa/src/components/SuperTeamTeamsPage";
import Head from "next/head";

const Page = () => (
  <>
    <Head>
      <meta name="robots" content="noindex" />
    </Head>
    <SuperTeamTeamsPage />
  </>
);

export default Page;
